import React from 'react';
import { facilities } from '../data';

export default function Facilities() {
  return (
    <section id="facilities" className="py-24 md:py-32 relative" style={{background:'#0F1629'}}>
      <div className="orb w-72 h-72 top-10 right-10 opacity-10" style={{background:'rgba(200,168,75,0.5)',animationDelay:'-2s'}} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16 reveal">
          <span className="section-tag">World-Class Infrastructure</span>
          <h2 className="font-playfair font-black text-white mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
            State-of-the-Art <span style={{color:'#C8A84B'}}>Facilities</span>
          </h2>
          <p style={{color:'rgba(212,207,197,0.6)',maxWidth:'500px',margin:'0 auto',fontSize:'0.9rem',lineHeight:'1.7'}}>
            Every detail of our environment is crafted for optimum learning, student comfort, and career success.
          </p>
        </div>

        {/* Bento-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2px]">
          {facilities.map((f, i) => (
            <div key={i} className={`reveal hover-lift p-8 border transition-all duration-300 cursor-default group ${i === 0 || i === 4 ? 'lg:col-span-1' : ''}`}
              style={{background:'rgba(10,10,20,0.8)',border:'1px solid rgba(200,168,75,0.08)',animationDelay:`${i*0.1}s`}}>
              <div className="text-3xl mb-5 group-hover:scale-110 transition-transform duration-300 inline-block">{f.icon}</div>
              <h3 className="text-white font-bold text-lg mb-3" style={{fontFamily:'Playfair Display,serif'}}>{f.name}</h3>
              <p style={{color:'rgba(212,207,197,0.55)',fontSize:'0.83rem',lineHeight:'1.7',marginBottom:'16px'}}>{f.desc}</p>
              <div className="flex flex-wrap gap-2">
                {f.tags.map(tag => (
                  <span key={tag} className="px-2 py-0.5 text-[10px] tracking-wider uppercase rounded-sm"
                    style={{background:'rgba(200,168,75,0.06)',border:'1px solid rgba(200,168,75,0.15)',color:'rgba(200,168,75,0.7)'}}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
